// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineMaximize2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 22.75H14C13.59 22.75 13.25 22.41 13.25 22C13.25 21.59 13.59 21.25 14 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9C4.39 2.75 2.75 4.39 2.75 9V9.98C2.75 10.39 2.41 10.73 2 10.73C1.59 10.73 1.25 10.39 1.25 9.98V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.9995 11.7502C12.8095 11.7502 12.6195 11.6802 12.4695 11.5302C12.1795 11.2402 12.1795 10.7602 12.4695 10.4702L16.2095 6.72021H13.9995C13.5895 6.72021 13.2495 6.38021 13.2495 5.97021C13.2495 5.56021 13.5795 5.22021 13.9995 5.22021H18.0095C18.3095 5.22021 18.5895 5.40021 18.6995 5.68021C18.8195 5.96021 18.7495 6.28022 18.5395 6.50022L13.5295 11.5302C13.3795 11.6802 13.1895 11.7502 12.9995 11.7502Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.0098 10.7402C17.5998 10.7402 17.2598 10.4002 17.2598 9.99021V5.97021C17.2598 5.56021 17.5998 5.22021 18.0098 5.22021C18.4198 5.22021 18.7598 5.56021 18.7598 5.97021V9.98021C18.7598 10.4002 18.4198 10.7402 18.0098 10.7402Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.85 22.75H5.15C2.49 22.75 1.25 21.51 1.25 18.85V16.15C1.25 13.49 2.49 12.25 5.15 12.25H7.85C10.51 12.25 11.75 13.49 11.75 16.15V18.85C11.75 21.51 10.51 22.75 7.85 22.75ZM5.15 13.75C3.31 13.75 2.75 14.31 2.75 16.15V18.85C2.75 20.69 3.31 21.25 5.15 21.25H7.85C9.69 21.25 10.25 20.69 10.25 18.85V16.15C10.25 14.31 9.69 13.75 7.85 13.75H5.15Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineMaximize2 };
